<template>
  <div class="wrap">
    <el-row type="flex" justify="space-between" class="footerBox">
      <dl>
        <dt>{{ lang == "en" ? "Contact Us" : "联系我们" }}</dt>
       
        <dd
          class="flex-ac"
          v-if="lang == 'zh'"
          :key="idx"
          v-for="(item, idx) in ContactInfos" 
        >
      
    <pre>{{item.ContactContent}}</pre> 
         


          <div class="qrcode" v-if="item.PicUrl">
            <img src="@/assets/img/icon_wx2.png" alt="" class="i1" />
            <div class="wx">
              <img :src="item.PicUrl" alt="" />
              <p>使用微信"扫一扫"</p>
            </div>
          </div>
        </dd>
      
        <div v-if="lang == 'en'" :key="idx" v-for="(item, idx) in ContactInfos">
          <dd class="fTitle">{{ item.Title }}</dd>
          <dd>{{ item.ContactContent }}</dd>
        </div>
      </dl>

      <dl>
        <dt>{{ lang == "en" ? "Related Links" : "相关链接" }}</dt>

        <dd :key="idx" v-for="(item, idx) in Links">
          <a @click="goURL(item.Url)" target="_blank">{{ item.Title }}</a>
        </dd>
      </dl>

      <dl>
        <dt>
          <router-link to="/cooperation">{{
            lang == "en" ? "Partners" : "合作伙伴"
          }}</router-link>
        </dt>
        <dt v-if="lang == 'zh'" :key="idx" v-for="(item, idx) in PlatformLinks">
          <a @click="goURL(item.Url)" target="_blank">{{ item.Title }}</a>
        </dt>
      </dl>

      <div class="codeBox">
        <el-image :src="QrCodePicUrl" fit="contain" class="code"></el-image
        >{{ lang == "en" ? "Zhongfu Shenying" : "中复神鹰" }}
      </div>
    </el-row>
    <el-row
      
      class="copryRight"
      justify="space-between"
      v-if="lang == 'zh'"
    >
      <span
        >Copyright @ 2022 中复神鹰碳纤维股份有限公司
        <a
          href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32070402010077"
          target="_blank"
          ref="nofollow"
          >苏公网安备 32070402010077号</a
        >
        备案号：<a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          ref="nofollow"
          >苏ICP备16034201号-2</a
        >&nbsp;&nbsp;本网站支持IPv6</span
      >
      <span style="float:right"><router-link to="/law">法律声明</router-link>
        <span class="store"><span>股票代码</span>{{ StockCode }}</span></span
      >
    </el-row>
    <el-row
      
      class="copryRight"
      justify="space-between"
      v-if="lang == 'en'"
    >
      <span
        >Copyright @ 2022 Zhongfu Shenying Carbon Fiber Co., Ltd.
        <a
          href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32070402010077"
          target="_blank"
          ref="nofollow"
          >SGWAB32070402020077</a
        >Registration No.:
        <a href="https://beian.miit.gov.cn/" target="_blank" ref="nofollow"
          >S-ICP-B160342101-2</a
        >&nbsp;&nbsp;Website Supports IPv6
      </span>
      <span style="float:right"><router-link to="/law">Legal Statement</router-link>
        <span class="store"><span>Stock Code</span> {{ StockCode }}</span></span
      >
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ContactUs: [],
      Links: [],
      PlatformLinks: [],
      QrCodePicUrl: "",
      StockCode: "",
      ContactInfos: "",
      open: false,
    };
  },
  props: ["lang"],
  methods: {
    goURL(url) {
      if (sessionStorage.getItem("openState") == "false") {
        window.open(url, "_blank");
      }
    },
  },
  mounted() {
    this.$api.footer().then((res) => {
      const {
        ContactUs,
        Links,
        PlatformLinks,
        QrCodePicUrl,
        StockCode,
        ContactInfos,
      } = res.Value;
      console.log(res.Value, "++footer");
      this.ContactUs = ContactUs;
      this.Links = Links;
      this.PlatformLinks = PlatformLinks;
      this.QrCodePicUrl = QrCodePicUrl;
      this.StockCode = StockCode;
      this.ContactInfos = ContactInfos;
    });
    this.open = sessionStorage.getItem("openState") == "true" ? true : false;
  },
};
</script>

<style lang="scss">
.footerBox {
  padding: 30px 0 0 0;
  color: #d6d6d6;
  font-size: 14px;

  dl,
  dt,
  dd {
    line-height: 30px;
    margin: 0;
    padding: 0;

    a {
      color: #727171;
    }
  }

  dt {
    font-size: 16px;
    color: #ddd;
    a {
      color: #ffffff;
    }
  }
  dd {
    color: #727171;
    pre{
      margin:0;padding:0;
      font-family:inherit;
    }
    .qrcode {
      position: relative;
      .i1 {
        margin-left: 15px;
        margin-top: 5px;
        width: 20px;
        opacity:.6;
      }
      .wx {
        display: none;
        width: 150px;
        background: #fff;
        position: absolute;
        padding-bottom: 25px;
        bottom: 40px;
        left: -45px;
        box-shadow: 1px 9px 33px 0px rgba(51, 51, 51, 0.4);
        padding: 5px;
        text-align: center;
        img {
          width: 100%;
          margin-bottom: -15px;
        }
        &::after {
          content: "";
          border: 10px solid transparent;
          border-top: 10px solid #fff;
          position: absolute;
          bottom: -20px;
          left: 46%;
          transform: translateX(-50%);
        }
      }
      &:hover {
        .wx {
          display: block;
        }
        .i1{
          opacity:1;
        }
      }
    }
  }
  .fTitle {
    color: #ddd;
    font-weight: 400;
  }
}

.copryRight {
  padding: 30px 0;
  margin-top: 25px;
  border-top: 1px solid rgba(#fff, 0.2);
}
.store {
  padding-left: 20px;
  span {
    padding-right: 5px;
  }
}
.el-footer {
  color: #d6d6d6 !important;
  a:hover {
    color: rgba(#fff, 0.88);
  }
  .codeBox {
    display: block;
    text-align: center;
  }
}
@media screen and (max-width:1160px) {
.copryRight{text-align:center;}
.copryRight span{width:100%;}
.copryRight span:nth-child(2){margin-top:10px;}
}
@media screen and (max-width:1420px) {
.en .copryRight{text-align:center;}
.en .copryRight span{width:100%;}
.en .copryRight span:nth-child(2){margin-top:10px;}
}
@media screen and (max-width: 768px) {
  .el-footer .codeBox{
    width:120px;
  }
  .footerBox dl dt,
  .footerBox dl dd {
    margin-right:10px;
    white-space: nowrap;
  }
  .footerBox dd .qrcode .i1{
    margin-left:5px;
  }
  .footerBox dd:nth-child(7) .qrcode .wx{
    left:-85px;
  }
  .footerBox dd:nth-child(8) .qrcode .wx{
    left:-125px;
  }
  .footerBox dd .wx::after{
   display:none;
  }
}
</style>
